import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import { WhenCaseIs } from '@morningtrain/react-resources'
import * as Fields from 'support/fields'
import * as Displays from 'support/displays'
import { Fieldset } from 'layouts/index'
import * as UI from 'ui'

export default function EmploymentTypeFormFields (props) {
  return (
    <UI.CardGroup>
      <UI.CardWithHeader header={<Translation name='sections.basic_information.title' />}>
        <Fieldset cols={2}>
          <Fields.Input name='name_translations.en' label={<Translation name='fields.name_translations.en.label' />} />
          <Fields.Input name='name_translations.da' label={<Translation name='fields.name_translations.da.label' />} />
          <Fields.Select name='type' enum='employment_type_category' label={<Translation name='fields.primary_working_area.label' />} />
          <Fields.Select name='status' enum='active_status' />
          <Fields.Select
            name='rank_badge'
            enum='badges'
            label={<Translation name='fields.badge.label' />}
            placeholder={<Translation name='fields.badge.placeholder' />}
          />
        </Fieldset>
      </UI.CardWithHeader>
      <UI.CardWithHeader header={<Translation name='sections.salary_steps.title' />}>
        <Fieldset>
          <Fields.Repeater
            name='salary_steps'
            itemHeader={(
              <span>
                <Displays.Enum name='salary_period_offset' enum='salary_period_offset' />
                <span>: </span>
                <Displays.Currency name='amount' />
                <span> </span>
                <Displays.Enum name='type' enum='salary_type' />
              </span>
                                     )}
            draggable={false}
          >
            <Fieldset cols={3}>
              <Fields.Hidden name='id' />
              <Fields.Select name='salary_period_offset' enum='salary_period_offset' />
              <Fields.Select name='type' enum='salary_type' />
              <Fields.Number name='amount' />
            </Fieldset>
          </Fields.Repeater>
        </Fieldset>
      </UI.CardWithHeader>
      <UI.CardWithHeader header={<Translation name='sections.permissions.title' />}>
        <Fieldset cols={2}>
          <Fields.RoleField />
          <Fields.Switch
            name='requires_extra_permissions'
            type='checkbox'
            label={<Translation name='fields.requires_extra_permissions.label' />}
          >
            <WhenCaseIs value>
              <Fields.ResourceSelector name='administrative_role_ids' resourceName='permissions.roles' optionsKey='translated_name' multiple />
            </WhenCaseIs>
          </Fields.Switch>
        </Fieldset>
      </UI.CardWithHeader>
      <div className='h-50 w-full' />
    </UI.CardGroup>
  )
}
